
import React from 'react'
import { mdx } from '@mdx-js/react'

/* @jsxRuntime classic */
/* @jsx mdx */



const layoutProps = {
  
};
const MDXLayout = "wrapper"
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <h1 {...{
      "id": "archived"
    }}>{`Archived`}</h1>
    <p>{`When a job posting feature has been significantly revised,
its prior documentation is moved to this section and retained for troubleshooting purposes.`}</p>
    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;